import AccountsBox from './AccountsBox';

export default AccountsBox;
